module.exports = __webpack_public_path__ + "img/ddwu_gallery10.51430ef9.jpg";